import { useLocation } from "react-router";
import { useEffect } from "react";
import { useFiltersStore } from "./store";
import { useRef } from "react";
import { useCallback } from "react";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function paramsToObject(entries: IterableIterator<[string, string]>) {
  const result: Record<string, any> = {};
  for (const [key, value] of entries) {
    result[key] = value;
  }
  return result;
}

function useFilters() {
  const query = useQuery();

  const values = useRef(paramsToObject(query.entries()));

  const { update, updateCount, reset, value, isOpen, close, open } =
    useFiltersStore();

  const handleUpdate = useCallback(
    (values: any) => {
      update(values);

      const params: any = {};

      let _count = Object.keys(values).filter((field) => {
        if (values[field] === "" || values[field] === undefined) {
          return false;
        }

        params[field] = values[field];

        return true;
      }).length;

      // setQuery({ ...params });

      updateCount(_count);
    },
    [update, updateCount]
  );

  useEffect(() => {
    handleUpdate(values.current);

    return () => {
      handleUpdate({});
    };
  }, [values, handleUpdate]);

  const handleReset = useCallback(() => {
    reset();

    close();

    // setQuery({});

    updateCount(0);
  }, [reset, close, updateCount]);

  const handleFilter = useCallback(
    (values) => {
      handleUpdate(values);

      close();
    },
    [handleUpdate, close]
  );

  return {
    isOpen,
    open,
    close,
    filters: value,
    reset: handleReset,
    filter: handleFilter,
    setFilters: handleUpdate,
  };
}

export default useFilters;
